module.exports = __webpack_public_path__ + "static/img/oulebi.e26bb03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/oulebi.jpg
// module id = EZvP
// module chunks = 0